import { ICustomIconProps } from '../_CustomIcon';
import { ReactComponent as IconComponent } from './Icon.svg';
import { StyledIcon } from './Styles';

const ResetIcon = (props: ICustomIconProps) => <StyledIcon icon={IconComponent} {...props} />;

export default ResetIcon;
